<template>
    <main>
        <page-header-compact>
            Configuración de parte de Sistemas
        </page-header-compact>

        <div class="container-fluid px-4">
            <div class="card mt-4">
                <div class="card-body">

                    <data-grid :data="pagination"
                           @changePage="changePage($event)"
                           @perPageChange="perPageChange($event)"
                           @search="search($event)">
                            <template #grid>
                                <grid-table>
                                    <template #head>
                                        <grid-cell-header class="bg-light"  v-for="(h,i) in headers" :key="`h_${i}`">{{h}}</grid-cell-header>
                                    </template>
                                    <template #body>
                                        <grid-row v-for="(item, i) in pagination.data" :key="`d_${i}`">
                                            <grid-cell class="text-center small">
                                                {{item.id}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.nombre}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.sexo}}
                                            </grid-cell>
                                            <grid-cell class="text-center ">
                                                {{item.descripcion}}
                                            </grid-cell>
                                            <grid-cell class="text-center ">
                                                {{item.activo}}
                                            </grid-cell>
                                            <grid-cell class="text-center   ">
                                                <button class="btn btn-outline-info btn-xs mx-2" type="button" @click="abrirModal(item.id)"  >
                                                      <i class="fas fa-edit fa-fw" ></i> Editar
                                                </button>
                                            </grid-cell>
                                            <grid-cell class="text-center   ">
                                                <button class="btn btn-outline-success btn-xs mx-2" type="button"  @click="cambiar(item.id)" >
                                                      <i class="fas fa-edit fa-fw" ></i> Cambiar
                                                </button>
                                            </grid-cell>

                                        </grid-row>
                                    </template>
                                </grid-table>
                            </template>
                            <template #action-button>
                                <button  class="btn btn-info btn-sm shadow-sm mb-2" type="button" data-toggle="modal" data-target="#modalPartesSistemas">
                                    Nuevo &nbsp;<i class="fas fa-plus"></i>
                                </button>
                            </template>
                    </data-grid>
                   <modalPartesSistemas ref="modalPartesSistemas" v-on:cargar-partes="getParteSistemas"></modalPartesSistemas>
                    

                </div>
            </div>
           
        </div>

    </main>
</template>
<script>
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import DataGrid from "../../../../components/common/utilities/DataGrid/DataGrid";
import GridTable from "../../../../components/common/utilities/DataGrid/GridTable";
import GridCellHeader from "../../../../components/common/utilities/DataGrid/GridCellHeader";
import GridRow from "../../../../components/common/utilities/DataGrid/GridRow";
import GridCell from "../../../../components/common/utilities/DataGrid/GridCell";
import Toast from '../../../../components/common/utilities/toast';
import modalPartesSistemas from "./modalPartesSistemas";
import partesRevisionSistemasService from "@/services/partesRevisionSistemasService";

export default {
    components: {
        PageHeaderCompact,GridCell, GridRow, GridCellHeader, GridTable, DataGrid,modalPartesSistemas
    },
    data(){
        return {
            partesistemas:{},
            headers : [
                'Id','Nombre','Sexo','Descripcion','Activo','Opción','Cambiar estado'
           ],
           pagination : {
               data : [],
               current_page : 1,
               page : 1,
               per_page : 5,
               search : '',
               total: '',
           }
        }
    },
    methods : {
        async getParteSistemas(){
            try {
                this.LoaderSpinnerShow();
                const response = (await partesRevisionSistemasService.list(this.pagination.search, this.pagination))?.data;
                this.partesistemas = response.data;
                console.log(response.data);
                this.pagination.data = response.data;
                this.pagination.current_page  = response.current_page;
                this.pagination.total = response.total;
                this.LoaderSpinnerHide();

            }catch (e) {
                console.error(e);
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        async cambiar(id){
           try {
                this.LoaderSpinnerShow();
                await partesRevisionSistemasService.cambiarEstado(id);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Estado cambiado exitosamente'
                });
                this.getParteSistemas();
           } catch (e) {
            console.error(e);
            this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
           }
        },
        changePage(page) {
            this.pagination.page = page;
            this.getParteSistemas();
        },
        perPageChange(per_page) {
            this.pagination.per_page = per_page;
            this.pagination.page = 1;
            this.getParteSistemas();
        },
        search(query){
            this.pagination.search = query;
            this.pagination.page = 1;
            this.getParteSistemas();
        },
        abrirModal(id){
           this.$refs.modalPartesSistemas.edit(id);
        }

    },
    async created(){
       await this.getParteSistemas();
    }
}
</script>
